<template>
    <div>
        <template v-if="condicion">
            <slot name="if"></slot>
        </template>
        <template v-else>
            <slot name="else"></slot>
        </template>
    </div>
</template>
<script>
export default {
    name: "ViewsSwitcher",
    props: {
        condicion: {
            type: Boolean
        }
    },
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {

    }
}
</script>

<style scoped></style>